import axios, {
  AxiosError,
  AxiosHeaders,
  AxiosRequestConfig,
  AxiosResponse,
} from 'axios';
import * as AxiosLogger from 'axios-logger';

import { logoutApp } from './logout';

declare const AXIOS_BASE: string;
declare const AXIOS_HEADERS: string;

/**
 * Subset of AxiosRequestConfig
 */
export type RequestConfig<TData = unknown> = {
  url?: string;
  method: 'GET' | 'PUT' | 'PATCH' | 'POST' | 'DELETE';
  params?: unknown;
  data?: TData | FormData | Blob;
  responseType?:
    | 'arraybuffer'
    | 'blob'
    | 'document'
    | 'json'
    | 'text'
    | 'stream';
  signal?: AbortSignal;
  headers?: AxiosRequestConfig['headers'];
};
/**
 * Subset of AxiosResponse
 */
export type ResponseConfig<TData = unknown> = {
  data: TData;
  status: number;
  statusText: string;
  headers?: AxiosResponse['headers'];
};

export type ResponseErrorConfig<TError = unknown> = AxiosError<TError>;

export const axiosInstance = axios.create({
  baseURL: typeof AXIOS_BASE !== 'undefined' ? AXIOS_BASE : undefined,
  headers:
    typeof AXIOS_HEADERS !== 'undefined'
      ? (JSON.parse(AXIOS_HEADERS) as AxiosHeaders)
      : undefined,
  //timeout: 7000,
  //withCredentials: true,
  //baseURL: Env.API_URL,
});

axiosInstance.interceptors.request.use((request) => {
  AxiosLogger.requestLogger(request);
  return request;
}, AxiosLogger.errorLogger);

axiosInstance.interceptors.response.use(
  (response) => {
    // const redirectLocation =
    //   response.headers['x-redirect'] ?? response.headers['X-Redirect'];
    // if (redirectLocation) {
    //   window.location = redirectLocation;
    //   response.data = null;
    // }

    return AxiosLogger.responseLogger(response, { data: false });
  },
  (err) => {
    if (!axios.isCancel(err)) {
      if (err.response) {
        if (err?.response?.status === 401) {
          console.log('signOut because 401');
          logoutApp({ replace: true });
        }
        return AxiosLogger.errorLogger(err);
      } else {
        console.error(err);
      }
    }
  },
);

export const client = async <TData, TError = unknown, TVariables = unknown>(
  config: RequestConfig<TVariables>,
): Promise<ResponseConfig<TData>> => {
  const promise = axiosInstance
    .request<TVariables, ResponseConfig<TData>>({ ...config })
    .catch((e: AxiosError<TError>) => {
      throw e;
    });

  return promise;
};

// export const client = axiosInstance;

export default client;
